import { GetStaticProps, GetStaticPaths } from 'next'
import React from "react";
import {getAllPodcast} from "../../lib/api";
import Layout from "../../components/layout";
import Link from "../../components/Link";
import CallToActionBlogBottom from "../../components/v2/call-to-action-blog-bottom";
import parse from "html-react-parser";
import dayjs from "dayjs";
import SearchBlog from "../../components/v2/blog/search-blog";
import CallToActionBlog from "../../components/v2/blog/call-to-action-blog";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import "../../styles/scss/blog.module.scss";

export default function Podcast({allPodcast}) {

    const { edges } = allPodcast;
    const heroPost = [edges[0]];
    const belowPost = edges.slice(1, 6);

    return (
        <Layout
            isHomePage={false}
            pageTitle={"Mastering Observability | Middleware Podcast for Developers"}
            ogImage={"/images/podcast/middleware-podcast.png"}
            metaTitle={"Mastering Observability | Middleware Podcast for Developers"}
            metaDesc={
                "Join top engineers on Middleware's podcast as we discuss real-world observability tactics. Debug faster, optimize performance, and build resilient systems. Listen now!"
            }
            uri={"/podcast/"}
            metaRobotsNoindex={"index"}
            metaRobotsNofollow={"follow"}
        >
            <div className={"middle-wrapper site-page blog-v2 "}>
                <div className={"blog-main-page"}>
                    <div className={`blog-hero unplugged`}>
                        <div className={"container"}>
                            <div className={"header-section"}>
                                <div className={"d-flex"}>
                                    <div className={"left-block"}>
                                        <div className={"category-title"}>Middleware Podcast</div>
                                        <h1><span className={"text-gradient"}>Observability </span> Unplugged</h1>
                                    </div>
                                    <div className={"right-block"}>
                                        <SearchBlog searchInputPostDetails={edges} parentSlug={"podcast"}/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div className={"blogs podcast-hero"}>
                        <div className={"container"}>
                            <div className={"d-flex"}>
                                {heroPost.map((__item, index)=> {
                                    let item = __item?.node;
                                    let link = item?.slug;
                                    if (item?.parentSlug?.parentSlug != null && item?.parentSlug?.parentSlug.length > 0) {
                                        link = item.parentSlug.parentSlug;
                                    }

                                    return <React.Fragment key={index}>
                                        <div className={"left-block"}>
                                            <Link href={`/podcast/${link == undefined ? "" : link}`} itemProp="url">
                                                <img src={item?.featuredImage?.node?.sourceUrl} alt={item?.title}
                                                     loading={'lazy'} width={100} height={100}/>
                                            </Link>
                                        </div>

                                        <div className={"right-block"}>
                                            <Link href={`/podcast/${link == undefined ? "" : link}`} itemProp="url"><h2>{item?.title}</h2></Link>
                                            {item !== undefined && parse(item.excerpt)}
                                            <div className={"podcast-guest"}>Guest appearance <Link href={item?.podcast?.guest?.profileUrl !== null && item?.podcast?.guest?.profileUrl !== undefined ? item?.podcast?.guest?.profileUrl : ""} target={"_blank"} skipLocaleHandling={true}><span>{item?.podcast?.guest?.name}</span></Link> Hosted By {item?.podcast?.hostBy?.profileUrl != null ? <Link href={item?.podcast?.hostBy?.profileUrl} skipLocaleHandling={true}><span>{item?.podcast?.hostBy?.name}</span></Link> : item?.podcast?.hostBy?.name}</div>
                                        </div>
                                    </React.Fragment>

                                })}


                            </div>
                        </div>
                    </div>

                    <CallToActionBlog title={"Subscribe to Our Blog for the Latest Updates"} />

                    <section className={"all-blogs-show site-page all-blogs-v2"}>
                        <div className={'container'}>
                            <div className={'section-tag news'}>Recent Uploads</div>
                            <div className={'content-container'}>
                                <div className={'content-wrapper'}>
                                    <div className={'d-flex'}>
                                        {belowPost.map(__post => {
                                            const post = __post?.node
                                            const title = post?.title
                                            return <div className={'inner-block'} key={post?.uri}>
                                                <Link href={`/podcast/${post?.slug == undefined ? "" : post?.slug}`} itemProp="url"> <div className={'image-wrapper'}>
                                                    <img src={post?.featuredImage?.node.sourceUrl} alt={title} />
                                                </div></Link>
                                                <div className={"category-episode"}>
                                                    <div className={"category knowledge"}>{post?.podcast?.episode}</div>
                                                    <div className={"category gray"}>{post?.seo?.readingTime} Mins</div>
                                                    <div className={"category gray"}>{dayjs(post?.date).format("D MMM YYYY")}</div>
                                                </div>
                                                <div>
                                                    <div key={post.uri}>
                                                        <article
                                                            className="post-list-item"
                                                            itemScope
                                                            itemType="http://schema.org/Article"
                                                        >
                                                            <header>
                                                                <Link href={`/podcast/${post?.slug == undefined ? "" : post?.slug}`} itemProp="url"><h4>
                                                                    {parse(title)}
                                                                </h4></Link>
                                                                <Link href={""} className={"read-more"}>Listen Now</Link>
                                                            </header>
                                                        </article>
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </section>


                    <div className={"observability-talk"}>
                        <div className={"container"}>
                            <h2>Observability Talk Playlist</h2>
                            <div className={"d-flex"}>
                                <div className={"left-block"}>
                                    <div className={"talks-block"}>
                                        <img src={"/images/podcast/observability-talks.png"} alt={"Observability Talks"} width={100} height={100} />
                                        <h3>Observability Talks by Middleware</h3>
                                        <Link href={"https://open.spotify.com/show/0hS2UJPixhCwamS8hC6BgX?si=dd93ca98bf32441e"} target={"_blank"} skipLocaleHandling={true}><button><img src={"/images/podcast/spotify.svg"} alt={"Spotify Music"} width={100} height={100} /> <span>Play on Spotify</span></button></Link>
                                        <Link href={"https://www.youtube.com/playlist?list=PLZrLsAi-5NXLVPSkrVYIIjQTli9nwklZ5"} target={"_blank"} skipLocaleHandling={true}><button><img src={"/images/podcast/youtube.svg"} alt={"Youtube Music"} width={100} height={100} /> <span>Play on Youtube</span></button></Link>
                                        <Link href={"https://music.amazon.com/podcasts/c45f918e-df95-443b-bce8-bfe454dff43d/observability-unplugged"} target={"_blank"} skipLocaleHandling={true}><button><img src={"/images/podcast/amazon.svg"} alt={"Amazon Music"} width={100} height={100} /> <span>Play on Amazon</span></button></Link>

                                    </div>
                                </div>
                                <div className={"right-block"}>
                                    <div className={"episodes"}>
                                        {edges.map((edge, index) => {
                                            return <div className={"episode"} key={index}>
                                                <div className={"category-episode"}>
                                                    <div className={"category knowledge"}>{edge?.node?.podcast?.episode}</div>
                                                    <div className={"category gray"}>{edge?.node?.seo?.readingTime} Mins</div>
                                                    <div className={"category gray"}>{dayjs(edge?.node?.date).format("D MMM YYYY")}</div>
                                                </div>
                                                <h3>{edge?.node?.title}</h3>
                                                <Link href={`/podcast/${edge?.node?.slug == undefined ? "" : edge?.node?.slug}`} className={"read-more"}>Learn More</Link>
                                            </div>
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <CallToActionBlogBottom />
            </div>
        </Layout>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    const translations = await serverSideTranslations(
      ctx?.locale ?? "en",
      ["common", "header", "footer"],
      nextI18NextConfig,
    );
    const allPodcast = await getAllPodcast()

    return {
        props: {
            ...translations,
            allPodcast: allPodcast,
            pageTitle: 'Mastering Observability | Middleware Podcast for Developers',
            ogImage: "/images/podcast/middleware-podcast.png",
            metaTitle: 'Mastering Observability | Middleware Podcast for Developers',
            metaDesc: "Join top engineers on Middleware's podcast as we discuss real-world observability tactics. Debug faster, optimize performance, and build resilient systems. Listen now!",
            description: "Join top engineers on Middleware's podcast as we discuss real-world observability tactics. Debug faster, optimize performance, and build resilient systems. Listen now!",
            uri: '/podcast/',
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
    }
}